const INITIAL_STATE = {
    totalReservasTotais: 0,
    totalReservado: 0,
    totalCheckIn: 0,
    totalNoShow: 0,
    totalCancelado: 0,
    totalRepasse: 0,
    totalPendente: 0,
    totalParcial: 0,
    passeiosOcupacao: [],
    alertasReservasPendentes: [],
    alertasPendenteProximoPasseio: []
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {

        case 'HOME_RESULTADOS_FETCHED':
            return {
                ...state,
                totalReservasTotais: action.payload.total_reservas ?? 0,
                totalReservado: action.payload.reservado,
                totalCheckIn: action.payload.check,
                totalNoShow: action.payload.no,
                totalCancelado: action.payload.cancelado,
                totalRepasse: action.payload.repasse,
                totalPendente: action.payload.pendente,
                totalParcial: action.payload.parcial,
                alertasReservasPendentes: action.payload.alertas?.reservas_pendentes ?? []
            }

        case 'HOME_PASSEIOS_OCUPACAO_FETCHED': {
            const payload = action.payload
            const ocupacao = Array.isArray(payload)
                ? payload
                : (Array.isArray(payload?.ocupacao) ? payload.ocupacao : [])

            return {
                ...state,
                passeiosOcupacao: ocupacao
            }
        }

        case 'HOME_ALERTAS_RESERVAS_PENDENTES_FETCHED':
            return {
                ...state,
                alertasReservasPendentes: Array.isArray(action.payload) ? action.payload : []
            }

        case 'HOME_ALERTAS_PENDENTE_PROXIMO_PASSEIO_FETCHED':
            return {
                ...state,
                alertasPendenteProximoPasseio: Array.isArray(action.payload) ? action.payload : []
            }

        default:
            return state
    }
}